/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';

function DragNode({ node, addToBuilder }) {
  const [isAdded, setIsAdded] = useState(false);
  const addedTimerRef = useRef(null);

  const triggerAddedState = () => {
    setIsAdded(true);
    if (addedTimerRef.current) {
      clearTimeout(addedTimerRef.current);
    }
    addedTimerRef.current = setTimeout(() => {
      setIsAdded(false);
      addedTimerRef.current = null;
    }, 1000);
  };

  useEffect(
    () => () => {
      if (addedTimerRef.current) {
        clearTimeout(addedTimerRef.current);
      }
    },
    []
  );

  const [{ isDragging }, dragRef] = useDrag(
    {
      type: 'DragNode',
      item: { node, type: 'DragNode' },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (_item, monitor) => {
        if (monitor.didDrop()) {
          triggerAddedState();
        }
      },
    },
    [node]
  );

  const handleAddToBuilder = (n) => {
    addToBuilder(n);
    triggerAddedState();
  };

  return (
    <div className="query-builder-search-section__drag-node">
      <div
        className="query-builder-search-section__drag-node-content"
        onClick={(e) => e.currentTarget === e.target && handleAddToBuilder(node)}
        onKeyDown={(e) => e.currentTarget === e.target && handleAddToBuilder(node)}>
        <ButtonWithIcon
          type="link"
          id="layerIcon"
          linkIconSize="s"
          data-e2e="querybuilder-layers"
          sprite={node.canExist && node.children && node.children.length > 1 ? 'Layers' : 'Layer'}
          onClick={(e) => {
            handleAddToBuilder(node);
            e.stopPropagation();
          }}>
          {node.displayName}
        </ButtonWithIcon>
        <div aria-live="polite" aria-atomic="true">
          {isDragging && <span className="sr-only">{node.displayName} is being dragged to query builder</span>}
          {isAdded && <span className="sr-only">{node.displayName} added to query builder</span>}
        </div>
        <div ref={dragRef}>
          <Flyout trigger="hover" flyout={<span aria-hidden="true">Drag field</span>} placement="bottom" shouldCloseOnESC theme="simple">
            <ButtonWithIcon
              id={`querybuilder-dragfield-${node.id}`}
              draggable
              className="cursor-move"
              onClick={(dragE) => dragE.stopPropagation()}
              linkIconSize="xxs"
              data-e2e="querybuilder-dragfield"
              iconOnly
              type="borderless"
              aria-grabbed={isDragging}
              sprite="Drag"
              tabIndex="-1"
              a11y={{ name: 'Drag', description: 'Drag Querylet' }}>
              drag
            </ButtonWithIcon>
          </Flyout>
        </div>
      </div>
    </div>
  );
}

DragNode.propTypes = {
  node: PropTypes.object,
  addToBuilder: PropTypes.func,
};

export default DragNode;
